<template>
  <svg :width="size" :height="size" :viewBox="viewBox">
      <g>
        <path d="M 34.5 42 C 32.851562 42 31.351562 40.949219 30.75 39.300781 C 30.75 39.148438 30.75 39 30.601562 39 L 17.25 39 C 17.25 39.148438 17.25 39.300781 17.101562 39.300781 C 16.648438 40.949219 15.148438 42 13.5 42 C 12.601562 42 12 42.601562 12 43.5 C 12 44.398438 12.601562 45 13.5 45 L 34.5 45 C 35.398438 45 36 44.398438 36 43.5 C 36 42.601562 35.398438 42 34.5 42 Z M 34.5 42 "/>
        <path d="M 40.5 4.5 L 7.5 4.5 C 4.949219 4.5 3 6.449219 3 9 L 3 31.5 C 3 34.050781 4.949219 36 7.5 36 L 40.5 36 C 43.050781 36 45 34.050781 45 31.5 L 45 9 C 45 6.449219 43.050781 4.5 40.5 4.5 Z M 18 28.5 C 13.050781 28.5 9 24.449219 9 19.5 C 9 15 12.300781 11.398438 16.5 10.648438 L 16.5 19.5 C 16.5 20.398438 17.101562 21 18 21 L 26.851562 21 C 26.101562 25.199219 22.5 28.5 18 28.5 Z M 19.5 18 L 19.5 10.648438 C 23.25 11.25 26.25 14.25 26.851562 18 Z M 37.5 27 L 31.5 27 C 30.601562 27 30 26.398438 30 25.5 C 30 24.601562 30.601562 24 31.5 24 L 37.5 24 C 38.398438 24 39 24.601562 39 25.5 C 39 26.398438 38.398438 27 37.5 27 Z M 37.5 21 L 31.5 21 C 30.601562 21 30 20.398438 30 19.5 C 30 18.601562 30.601562 18 31.5 18 L 37.5 18 C 38.398438 18 39 18.601562 39 19.5 C 39 20.398438 38.398438 21 37.5 21 Z M 37.5 15 L 31.5 15 C 30.601562 15 30 14.398438 30 13.5 C 30 12.601562 30.601562 12 31.5 12 L 37.5 12 C 38.398438 12 39 12.601562 39 13.5 C 39 14.398438 38.398438 15 37.5 15 Z M 37.5 15 "/>
      </g>
    </svg>

</template>

<script>
export default {
  props: {
    size: {
      type: [Number, String],
      default: 48
    },
    box: {
      type: [Number, String],
      default: 48
    }
  },
  computed: {
    viewBox() {
      return `0 0 ${this.box} ${this.box}`
    }
  }
}

</script>

<style scoped>

</style>